export const EmployeeParser = {
  invite ({ user_invite: invitation = {} }) {
    const { token, user_email: email, company_name: company, answered_at: answered } = invitation
    return { token, email, company, isRead: Boolean(answered) }
  }
}
